import { render, staticRenderFns } from "./ExchangeNext.vue?vue&type=template&id=72a8ada0&scoped=true&"
import script from "./ExchangeNext.vue?vue&type=script&lang=js&"
export * from "./ExchangeNext.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeNext.vue?vue&type=style&index=0&id=72a8ada0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a8ada0",
  null
  
)

export default component.exports